import { differenceInDays, set } from 'date-fns';

export function determineActiveDays(activeDate?: Date): number {
    const emptyHours = {
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
    };
    const date = activeDate != null ? new Date(activeDate) : new Date();
    const activeFinal = set(date, emptyHours);
    const todayDate = set(new Date(), emptyHours);
    return differenceInDays(todayDate, activeFinal);
}
